import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	TextField,
	withStyles,
	Grid,
	LinearProgress,
	FormHelperText,
} from '@material-ui/core'
import onClickOutside from 'react-onclickoutside'
import { handleDefaultFieldChange } from 'actions/contacts/addOrEdit'
import { createOrUpdateContact } from 'actions/contacts'
import { withRouter } from 'react-router-dom'
import language from 'utils/vast-languagepack'

export default withRouter(
	connect(
		(state) => {
			// console.log(state.addOrEditContact.fields.first_name.error)
			// console.log(Object.keys(state.addOrEditContact.fields.first_name.error))
			return {
				first_name: state.addOrEditContact.fields.first_name.value,
				middle_name: state.addOrEditContact.fields.middle_name.value,
				last_name: state.addOrEditContact.fields.last_name.value,
				firstNameError: Object.keys(
					state.addOrEditContact?.fields?.first_name?.error || {},
				).join(', '),
				middleNameError: Object.keys(
					state.addOrEditContact?.fields?.middle_name?.error || {},
				).join(', '),
				lastNameError: Object.keys(
					state.addOrEditContact?.fields?.last_name?.error || {},
				).join(', '),
			}
		},
		(dispatch) =>
			bindActionCreators(
				{ handleDefaultFieldChange, createOrUpdateContact },
				dispatch,
			),
	)(
		withStyles((theme) => {
			const light = theme.palette.type === 'light'
			const bottomLineColor = light
				? 'rgba(0, 0, 0, 0.42)'
				: 'rgba(255, 255, 255, 0.7)'

			return {
				underline: {
					'&:before': {
						'@media (hover: none)': {
							borderBottom: `1px solid ${bottomLineColor}`,
						},
						borderBottom: 0,
					},
					'&:hover:not($disabled):not($focused):not($error):before': {
						borderBottom: `1px solid ${bottomLineColor}`,
					},
				},
				focused: {},
				disabled: {},
				error: {},
				input: {
					color: theme.palette.secondary.main,
					fontSize: '34px',
				},
				inputMobile: {
					color: theme.palette.secondary.main,
					fontSize: '18px',
				},
			}
		})(
			onClickOutside(
				class Name extends Component {
					state = {
						focused: false,
						typing: false,
						requesting: false,
					}

					handleClickOutside = (evt) => {
						this.setState({ focused: false })
					}

					handleChange = (name, value) => {
						clearTimeout(this.timeout)
						this.props.handleDefaultFieldChange(name, value)
						this.setState({ typing: true })
						this.timeout = setTimeout(() => {
							this.setState({ requesting: true })
							this.props.createOrUpdateContact().then(
								(payload) => {
									this.setState({ requesting: false })
									if (
										this.props.history.location.pathname.slice(0, 13) ===
										'/contacts/new'
									) {
										this.props.history.replace(`/contacts/${payload.id}`)
									}
								},
								(err) => {
									this.setState({ requesting: false })
									return
								},
							)
							this.setState({ typing: false })
						}, 500)
					}

					render() {
						const {
							classes,
							first_name,
							middle_name,
							last_name,
							mobile,
							firstNameError,
							middleNameError,
							lastNameError,
						} = this.props

						return (
              <div>
                {this.state.focused ? (
                  <Grid container>
                    <Grid item xs={mobile ? 12 : 4}>
                      <TextField
                        onChange={e =>
                          this.handleChange('first_name', e.target.value)
                        }
                        value={first_name}
                        fullWidth
                        placeholder={language.contacts.add.firstName}
                        InputProps={{
                          classes: {
                            underline: classes.underline,
                            input: mobile ? classes.inputMobile : classes.input,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={mobile ? 12 : 4}>
                      <TextField
                        onChange={e =>
                          this.handleChange('middle_name', e.target.value)
                        }
                        value={middle_name}
                        fullWidth
                        placeholder={language.contacts.add.middleName}
                        InputProps={{
                          classes: {
                            underline: classes.underline,
                            input: mobile ? classes.inputMobile : classes.input,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={mobile ? 12 : 4}>
                      <TextField
                        onChange={e =>
                          this.handleChange('last_name', e.target.value)
                        }
                        value={last_name}
                        fullWidth
                        placeholder={language.contacts.add.lastName}
                        InputProps={{
                          classes: {
                            underline: classes.underline,
                            input: mobile ? classes.inputMobile : classes.input,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {this.state.requesting ? (
                        <LinearProgress color="secondary" />
                      ) : null}
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container>
                    <Grid item xs={12}>
                      <TextField
                        onFocus={() => this.setState({ focused: true })}
                        value={
                          first_name.length ||
                          middle_name.length ||
                          last_name.length
                            ? `${first_name} ${middle_name} ${last_name}`
                            : ''
                        }
                        fullWidth
                        placeholder={language.contacts.add.name}
                        InputProps={{
                          classes: {
                            underline: classes.underline,
                            input: mobile ? classes.inputMobile : classes.input,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
                <FormHelperText
                  error={Boolean(
                    firstNameError || middleNameError || lastNameError,
                  )}
                >{`${firstNameError ? `${firstNameError}, ` : ''}${
                  middleNameError ? `${middleNameError}, ` : ''
                }${lastNameError ? `${lastNameError}, ` : ''}`}</FormHelperText>
              </div>
            )
					}
				},
			),
		),
	),
)
